import { DateTime } from 'luxon';

export interface QuotesChangeRange {
  readonly key: string;
  readonly fromDate: string;
}

export function makeChangeRanges(date = DateTime.local()): QuotesChangeRange[] {
  return [
      { key: '1M', fromDate: date.minus({months: 1}).toISODate() },
      { key: '3M', fromDate: date.minus({months: 3}).toISODate() },
      { key: '6M', fromDate: date.minus({months: 6}).toISODate() },
      { key: '12M', fromDate: date.minus({months: 12}).toISODate() },
      { key: '36M', fromDate: date.minus({months: 36}).toISODate() },
      { key: '60M', fromDate: date.minus({months: 60}).toISODate() },
      { key: 'YTD', fromDate: date.startOf('year').toISODate() }
  ];
}
